import React, { useContext, useEffect } from 'react';
import { IEditVideoContext, EditVideoContext } from '../../../../../editVideoState/editVideoContext';
import {
	IWithAdditionalValidationContext,
	WithAdditionalValidationContext,
} from 'components/WithAdditionalValidation/withAdditionalValidationContext';
import StudioField from './components/StudioField/StudioField';
import NameVideoInput from './components/NameVideoInput';
import CategorySelect from './components/CategorySelect';
import VideoFileBlock from './components/VideoFileBlock/VideoFileBlock';
import TranslationsMultipleSelect from './components/TranslationsMultipleSelect';
import BtnBlock from './components/BtnBlock';
import Text from 'components/Text/Text';
import { Form } from 'antd';
import { getFileIdForSubmit, preventDefaultForEnterKey } from 'utils/helpers';
import style from './InputFields.module.scss';

const InputFields: React.FC = () => {
	const { setMainFormValidationFail, additionalValidationErrors } = useContext<IWithAdditionalValidationContext>(
		WithAdditionalValidationContext,
	);

	const {
		changeTypeOfModalWindow,
		setFetchedStudios,
		setIDStudio,
		refetchStudios,
		changeName,
		setIDCategory,
		setFetchedCategories,
		changeFileData,
		setIDsLanguages,
		setFetchedLanguages,
		setDataForSubmit,
		videoID,
		IDSelectedStudio,
		needRefetchStudios,
		name,
		IDSelectedCategory,
		videoFileData,
		iconFilePath,
		iconFileId,
		IDsSelectedLanguages,
		translations,
	} = useContext<IEditVideoContext>(EditVideoContext);
	const [form] = Form.useForm();

	useEffect(() => {
		form.setFieldsValue({
			IDSelectedStudio,
			name,
			IDSelectedCategory,
			IDsSelectedLanguages,
		});
	}, [IDSelectedStudio, name, IDSelectedCategory, IDsSelectedLanguages]);

	const submit = async () => {
		const someTranslationIsEmpty = translations.some((translation) => translation.name === '');
		if (someTranslationIsEmpty) {
			changeTypeOfModalWindow('someTranslationIsEmpty');
			return;
		}

		setMainFormValidationFail(false);

		setDataForSubmit({
			id: videoID,
			name,
			videoCategoryId: IDSelectedCategory || '',
			videoStudioId: IDSelectedStudio || '',
			iconFileId: getFileIdForSubmit({ fileId: iconFileId, filePath: iconFilePath }),
			videoFileId: videoFileData.fileId,
			translations: translations,
		});
		additionalValidationErrors.length
			? setMainFormValidationFail(true)
			: changeTypeOfModalWindow('toConfirmSubmit');
	};

	const handleFormValidationFail = () => {
		setMainFormValidationFail(true);
	};

	return (
		<div className={style.container} data-test="InputFields">
			<Form
				form={form}
				name="basic"
				onFinish={submit}
				onKeyPress={preventDefaultForEnterKey}
				onFinishFailed={handleFormValidationFail}
				layout="vertical">
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="mainInfoHeading"
						theme="secondary"
						size="l"
						weight="bold"
						display="inline"
					/>
					<StudioField
						setFetchedStudios={setFetchedStudios}
						setIDStudio={setIDStudio}
						refetchStudios={refetchStudios}
						changeTypeOfModalWindow={changeTypeOfModalWindow}
						needRefetchStudios={needRefetchStudios}
					/>
					<NameVideoInput changeName={changeName} />
					<CategorySelect setIDCategory={setIDCategory} setFetchedCategories={setFetchedCategories} />
				</div>
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="setupNewVideoFileHeading"
						theme="secondary"
						size="l"
						weight="bold"
						display="inline"
					/>
					<Text
						className={style.requiredLabel}
						translationNameSpace="form"
						translationKey="requiredLabel"
						theme="secondary"
						size="s"
						weight="bold"
						display="inline"
					/>
					<VideoFileBlock changeFileData={changeFileData} changeTypeOfModalWindow={changeTypeOfModalWindow} />
				</div>
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="translationsHeading"
						theme="secondary"
						size="l"
						weight="bold"
					/>
					<TranslationsMultipleSelect
						setIDsLanguages={setIDsLanguages}
						setFetchedLanguages={setFetchedLanguages}
					/>
				</div>
				<BtnBlock />
			</Form>
		</div>
	);
};

export default InputFields;
